module.exports = __webpack_public_path__ + "img/icons.30689cbf.jpg";